import Button from 'components/Button';
import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import Error from 'components/form/Error';
import ArrowRightIcon from 'components/icons/ArrowRight';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ButtonsContainer, InputContainer } from '.';
import { MentoringContext } from '..';
import ChangeReferee from './ChangeReferee';
import InputLike from './components/InputLike';

const Waiting: FC = () => {
  const { mentorship } = useContext(MentoringContext);
  const [interruptLoading, setInterruptLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleInterrupt = () => {
    setInterruptLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'INTERRUPTED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setInterruptLoading(false);
      });
  };

  const handleFinish = () => {
    setFinishLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'FINISHED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setFinishLoading(false);
      });
  };

  return (
    <div>
      <InputContainer>
        <p>Mentor associé</p>
        <Link
          to={`/admin/mentoring/mentors/${mentorship?.mentor?.id}/mentoring/ongoing/`}
        >
          <InputLike>
            <p>
              {mentorship?.mentor?.firstName +
                ' ' +
                mentorship?.mentor?.lastName}
            </p>
            <span>
              <MentorshipStatusChip status={mentorship?.status || 'ONGOING'} />
              <ArrowRightIcon />
            </span>
          </InputLike>
        </Link>
        <ChangeReferee mentorship={mentorship} />
      </InputContainer>
      <ButtonsContainer>
        <Button
          color="primary"
          onClick={handleInterrupt}
          loading={interruptLoading}
        >
          Interrompre le mentorat
        </Button>
        <Button color="primary" onClick={handleFinish} loading={finishLoading}>
          Terminer le mentorat
        </Button>
      </ButtonsContainer>
      {error && <Error>Une erreur est survenue.</Error>}
    </div>
  );
};

export default Waiting;
